// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldTick = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      viewBox: '0 0 8 6',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.7595 5.18959C2.63143 5.18959 2.50977 5.13837 2.42013 5.04872L0.60802 3.23662C0.422327 3.05092 0.422327 2.74357 0.60802 2.55788C0.793712 2.37218 1.10107 2.37218 1.28676 2.55788L2.7595 4.03061L6.05074 0.739367C6.23643 0.553674 6.54379 0.553674 6.72948 0.739367C6.91517 0.92506 6.91517 1.23241 6.72948 1.41811L3.09887 5.04872C3.00922 5.13837 2.88756 5.18959 2.7595 5.18959Z',
      fill: 'currentColor',
      stroke: 'currentColor',
      strokeWidth: '0.4',
    }),
  );

export { IconBoldTick };
